import { IsUUID, IsNotEmpty } from 'class-validator';

export class GetAccountSettingsDto {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;
}
